import { lazy } from "react"

export const Routes = [
    {
        path: "/dashboard",
        component: lazy(() => import("../views/dashboard")),
        meta: {
            general: true
        }
    },
    {
        path: '/qpu/faculty',
        component: lazy(() => import('../views/faculty-list')),
        meta: {
            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/teachers',
        component: lazy(() => import('../views/teacher-list')),
        meta: {

            action: "call",
            resource: "NoPermissionCode"
        }
    },
    {
        path: '/qpu/study-years',
        component: lazy(() => import('../views/study-year-list')),
        meta: {

            action: "call",
            resource: "NoPermissionCode"
        }
    },
    {
        path: '/qpu/graduated-students',
        component: lazy(() => import('../views/graduated-student-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/scientific-research',
        component: lazy(() => import('../views/scientific-research-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/courses',
        component: lazy(() => import('../views/course-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/lectures',
        component: lazy(() => import('../views/lecture-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/labs',
        component: lazy(() => import('../views/lab-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/dynamic-content',
        component: lazy(() => import('../views/dynamic-content-list')),
        exact: true,
        meta: {

            action: "call",
            resource: "NoPermissionCode"
        }
    },
    {
        path: '/qpu/dynamic-content/duplicates',
        component: lazy(() => import('../views/dynamic-content-duplicates')),
        exact: true,
        meta: {

            action: "call",
            resource: "NoPermissionCode"
        }
    },
    {
        path: '/qpu/best-employees',
        component: lazy(() => import('../views/best-employee-list')),
        meta: {

            action: "call",
            resource: "FACULTY_ADMIN"
        }
    },
    {
        path: '/qpu/vacancies',
        component: lazy(() => import('../views/vacancy-list')),
        meta: {

            action: "call",
            resource: "NoPermissionCode"
        }
    },
    {
        path: '/qpu/student-registrations',
        component: lazy(() => import('../views/student-registration-list')),
        meta: {
            action: "call",
            resource: "FACULTY_ADMIN"
        }
    }
]
